import * as React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ISalesTeam } from '@user/store/salesTeam'

type Props = {
  branchId: string
  name: string
  errorText?: string
}

export function SalesTeamSelect(props: Props) {
  const { branchId, name, errorText } = props
  const {
    options,
    getOptionLabel,
    initialOption,
    loadSalesTeamUsers,
    isSubmitting,
    showError,
    helperText,
    height,
  } = useData({
    branchId,
    name,
  })
  const { handelChange } = useHandlers({ loadSalesTeamUsers, name })

  return (
    <Box>
      <Select<ISalesTeam>
        disabled={isSubmitting}
        getLabel={getOptionLabel}
        items={options}
        onChange={handelChange}
        value={initialOption}
        error={showError}
        required
        label={'Sales Team'}
        optionMode={'custom'}
        testId="sales-team-select"
        renderOption={(props, team: ISalesTeam) => (
          <MenuItem
            sx={{
              height: height,
              minHeight: height,
            }}
            {...props}
            key={team.id}
            value={team.id}
          >
            <Stack>
              <Typography variant="body1">{team.name}</Typography>
              <Typography variant="body2">{team.branchName}</Typography>
            </Stack>
          </MenuItem>
        )}
      />
      {initialOption == null && !(showError || errorText) && (
        <FormHelperText sx={{ ml: 1 }}>
          Select a Sales Team to see the list of Owners.
        </FormHelperText>
      )}
      {(showError || errorText) && (
        <FormHelperText sx={{ ml: 1 }} error>
          {errorText || helperText}
        </FormHelperText>
      )}
    </Box>
  )
}
